import { usePortfolioImages } from 'hooks/portfolio/usePortfolioImages';

export const usePortfolioPage = () => {
  const { isLoading, images } = usePortfolioImages();

  return {
    isLoading,
    images,
  };
};
